import RubricGradingCardList from './grading-card/RubricGradingCardList'
import React from 'react'
import { getAnswerByRubric } from '../../../../../../../../../utils/question.helper'
import GradingCard from './grading-card/GradingCard'

const GradingSection = ({ answers, question }) => {
    const questionRubrics = question.questionRubrics || []
    
    // Multiple rubrics - show list of grading cards
    if (questionRubrics.length > 1) {
        return (
            <RubricGradingCardList 
                question={question} 
                questionRubrics={questionRubrics}
                answers={answers} 
            />
        )
    }
    
    // Single rubric (or none) - show single grading card
    const questionRubric = questionRubrics[0]
    return (
        <GradingCard 
            questionRubric={questionRubric}
            answer={getAnswerByRubric(answers, questionRubric, question)} 
        />
    )
}

export default GradingSection
